<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <el-button type="primary" @click="onClickAdd">新建活动</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="name" label="活动名称"></el-table-column>
      <el-table-column prop="scopeType" label="范围类型">
        <template slot-scope="scope">
          <span v-if="scope.row.scopeType === 'brand_category'">指定品牌品类</span>
          <span v-if="scope.row.scopeType === 'spu'">SPU导入</span>
        </template>
      </el-table-column>
      <el-table-column label="活动状态">
        <template slot-scope="scope">
          <template v-if="scope.row.status === 1">
            <span class="status-point"></span>
            未开始
          </template>
          <template v-if="scope.row.status === 2">
            <span class="status-point green"></span>
            进行中
          </template>
          <template v-if="scope.row.status === 3">
            <span class="status-point gray"></span>
            已结束
          </template>
        </template>
      </el-table-column>
      <el-table-column label="活动生效时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.startTime) }} ~ {{ dateFormat(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="techServiceFeePercent" label="手续费比例">
        <template slot-scope="scope">
          {{ scope.row.techServiceFeePercent }}%
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.status === 1 || scope.row.status === 2" @click="editItem(scope.row)">编辑活动</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="操作时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="updatedBy" label="操作人"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import utils from '@/utils/util';
import {
  getSellerServiceFeePromotionList,
} from "../api";

export default {
  data() {
    return {
      fullscreenLoading: false,
      tableData: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      getSellerServiceFeePromotionList().then(res => {
        if (res.data && res.data.data) {
          this.tableData = res.data.data;
        }
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onClickAdd() {
      this.$router.push({
        path: '/seller/promotion/serviceFee/create',
      })
    },
    editItem(row) {
      this.$router.push({
        path: '/seller/promotion/serviceFee/edit/' + row.id,
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.status-point {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  background-color: #F56C6C;
  border-radius: 6px;

  &.green {
    background-color: #67C23A;
  }
  &.gray {
    background-color: #909399;
  }
}
</style>
